module.exports = __webpack_public_path__ + "TextaNarrow-Regular-webfont.9c4ca869178672cca906.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/assets/fonts/TextaNarrow-Regular-webfont.ttf
// module id = ../../../../../src-admin/assets/fonts/TextaNarrow-Regular-webfont.ttf
// module chunks = styles